export class RegisterUser {
    username?: string;
    password?: string;
    email?: string;
    name?: string;
    surname?: string;
    avatar?: string | ArrayBuffer;
    extention?: string;
    captchaToken?: string;
    termsAccepted?: boolean;
    privacyAcknowledged?: boolean;
    scientificLicenseAccepted?: boolean;
    scientificLicenseCode?: string;

    constructor() {}
}

export interface RegistrationPolicy {
    username: {
        pattern: string;
        minLength: number;
        maxLength: number;
    };
    password: {
        minLength: number;
    };
    avatar: {
        maxBytes: number;
        extensions: string[];
    };
    terms: {
        required: boolean;
        url: string;
        version: string;
    };
    privacy?: {
        required: boolean;
        url: string;
        version: string;
    };
    communityGuidelines?: {
        url: string;
    };
    scientificLicense?: {
        code: string;
        title: string;
        url?: string;
    };
    confirmEmailEnabled?: boolean;
    captchaRequired?: boolean;
}

export interface UsernameAvailability {
    available: boolean;
    reason?: string;
    message?: string;
}

export interface LoginPolicy {
    passwordResetEnabled: boolean;
    rememberSessionEnabled?: boolean;
    sessionRefreshTokenSeconds?: number;
    refreshTokenSeconds?: number;
    termsUrl?: string;
    privacyUrl?: string;
}

export interface LoginUser {
    email: string;
    password: string;
}

export interface LoginPayload {
    message: string;
    access_token?: string;
    refresh_token?: string;
    username?: string;
}

export interface LogoutPayload {
    msg: string;
}

export interface JWT {
    header: {
        typ: string;
        alg: string;
    };
    payload: JWTPayload;
}

export interface JWTPayload {
    iat: number;
    nbf: number;
    jti: string;
    exp: number;
    identity: string;
    fresh: boolean;
    type: string;
}

export interface TokenRefresh {
    access_token: string;
}

export interface UserInfo {
    message: string;
    features?: any;
}
